module.exports = __webpack_public_path__ + "static/media/analytics.676d211f.jpg";